import { WorkplaceInCoworkingType } from 'shared/enums/WorkplaceInCoworkingType';
import { EObjectType } from 'shared/utils/formatters/getCustomUrl';

export function getPlaceGaObjectType(type: WorkplaceInCoworkingType): EObjectType {
  switch (type) {
    case WorkplaceInCoworkingType.FixedWorkplace:
      return EObjectType.FIXED_PLACE;

    case WorkplaceInCoworkingType.FlexibleWorkplace:
      return EObjectType.FLEX_PLACE;

    default:
      throw new Error(`getPlaceGaObjectType поле ${type} в енаме WorkplaceInCoworkingType не объявлено`);
  }
}
